import { Autocomplete, Box, Button, Chip, Stack, TextField, Typography } from '@mui/material';
import { ALL_STATES } from './data';

interface Props {
  value: string[];
  onChange: (next: string[]) => void;
}

export default function StatesPicker({ value, onChange }: Props) {
  const allSelected = value.length === ALL_STATES.length;

  return (
    <Box>
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1.5}>
        <Typography variant="body2" color="text.secondary">
          {value.length} state{value.length === 1 ? '' : 's'} selected
        </Typography>
        <Button
          size="small"
          variant="outlined"
          onClick={() => onChange(allSelected ? [] : [...ALL_STATES])}
        >
          {allSelected ? 'Clear all' : 'Select all 50 + DC'}
        </Button>
      </Stack>

      <Autocomplete
        multiple
        options={ALL_STATES}
        value={value}
        onChange={(_, next) => onChange(next)}
        disableCloseOnSelect
        renderTags={(selected, getTagProps) =>
          selected.map((state, index) => (
            <Chip
              {...getTagProps({ index })}
              key={state}
              label={state}
              size="small"
              color="primary"
              variant="outlined"
            />
          ))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={value.length === 0 ? 'Type a state name…' : ''}
            size="small"
          />
        )}
      />
    </Box>
  );
}
